import React from "react";
import "./styles.css";
import {
  mailtoAlliances,
  responseTime,
  inputsArray,
  optionsArray,
  placeholderMessage,
} from "../../constants/contents";

function AlliancesForm() {
  return (
    <div className="alliances-form">
      <h1>Regístrate como Aliado</h1>
      <p>{responseTime}</p>
      <form
        className="email-form"
        action={mailtoAlliances}
        method="POST"
        enctype="text/plain"
      >
        {/* Inputs */}
        {inputsArray.map((input) => (
          <div className="inputs-array">
            <label htmlFor={input.name}>{input.label}</label>
            <input type={input.type} name={input.name} required />
          </div>
        ))}

        {/* Select */}
        <label for="alliance">Tipo de alianza</label>
        <select name="alliance">
          <option disabled selected>
            Selecciona una opción:
          </option>
          {optionsArray.map((option) => (
            <option value={option.value}>{option.value}</option>
          ))}
        </select>

        {/* Textarea */}
        <label htmlFor="message">Mensaje:</label>
        <textarea name="message" placeholder={placeholderMessage}></textarea>
        <input type="submit" value="Enviar"></input>
      </form>
    </div>
  );
}

export default AlliancesForm;
